import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import heroImage1 from "../assets/images/img-6.jpg";
import heroImage2 from "../assets/images/img-2.jpeg";
import heroImage3 from "../assets/images/img-3.jpeg";
import heroImage4 from "../assets/images/img-4.jpeg";
import heroImage5 from "../assets/images/img-5.jpeg";

const Hero = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const images = [heroImage1, heroImage2, heroImage3, heroImage4, heroImage5];

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentImageIndex((prev) => (prev + 1) % images.length);
        }, 5000);

        return () => clearInterval(timer);
    }, [images.length]);

    return (
        <section id="hero" className="relative h-screen overflow-hidden">
            {/* Preload the first hero image to speed up initial paint */}
            <img
                src={images[0]}
                alt=""
                loading="eager"
                decoding="async"
                fetchpriority="high"
                aria-hidden="true"
                style={{
                    position: "absolute",
                    width: 0,
                    height: 0,
                    overflow: "hidden",
                    opacity: 0,
                }}
            />
            <AnimatePresence initial={false}>
                <motion.div
                    key={currentImageIndex}
                    initial={{ x: "100%" }}
                    animate={{ x: 0 }}
                    exit={{ x: "-100%" }}
                    transition={{
                        duration: 1.2,
                        ease: [0.4, 0, 0.2, 1],
                        type: "tween",
                    }}
                    className="absolute inset-0 w-full h-full"
                >
                    <div
                        className="absolute inset-0 bg-cover bg-center w-full h-full"
                        style={{
                            backgroundImage: `url(${images[currentImageIndex]})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                        }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-black/40" />
                </motion.div>
            </AnimatePresence>

            <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-20">
                {images.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => setCurrentImageIndex(index)}
                        className={`w-3 h-3 rounded-full transition-all duration-300 ${
                            currentImageIndex === index
                                ? "bg-primary w-8"
                                : "bg-white"
                        }`}
                        aria-label={`Slide ${index + 1}`}
                    />
                ))}
            </div>

            <div className="relative container mx-auto h-full flex items-center justify-end container-padding">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="text-white max-w-2xl text-right"
                >
                    <h1 className="text-4xl md:text-6xl font-bold mb-6">
                        Transform your enterprises with technology-driven
                        facilities management
                    </h1>
                    <p className="text-xl mb-8">
                        Solutions that can boost property
                    </p>
                    <div className="flex justify-end">
                        <a
                            href="https://wa.me/94766496256"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-primary text-secondary px-8 py-3 rounded-md font-semibold hover:bg-opacity-90 transition-all"
                        >
                            Contact Us
                        </a>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default Hero;
